import React from 'react';
import { Alert } from '@mui/material';
import { Linkify } from '/@/app/linkify';

export const StepInfoBlock = ({text}) => {
    return (
        <>
            {text &&
                <Alert severity="info" sx={{ mt: 3, mb: 3 }}>
                    <Linkify text={text} />
                </Alert>
            }
        </>
    )
}
